import React from 'react'
import * as AppHomeActions from '../../actions/mobileapp/HomeActions'
import {Table, Popup, Icon, Loader, Button} from 'semantic-ui-react'
import {Elementslist} from './homeelements';
import {useFirebase, useFirestore} from 'react-redux-firebase';

export function Home(props) {
    const firebase = useFirebase();
    const firestore = useFirestore();
    //const dispatch = useDispatch()

    function devFunc(){
        (async () => {
            let data = await firestore.get('/environments/dev/channels/app/home/content');
            let content = data.data();
            console.log(content);
            await firestore.set('/environments/prod/channels/app/home/content', content);
        })();
    }
    //const state = props.state;
    
    return (
        <div style={{
            display: 'flex',
            position: 'fixed',
            left: '0px',
            right: '0px',
            bottom: '0px',
            top: '41px'
        }}>
            <div style={{
                width: '300px',
                backgroundColor: '#EEEEEE',
                borderRight: '1px solid #DDDDDD',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{
                    flexGrow: 1,
                    overflow: 'auto'
                }}>
                    <Elementslist />
                    <div style={{
                        padding: '10px'
                    }}>
                        <Button color="green" fluid><Icon name="plus" onClick={(e) => dispatch(AppHomeActions.addElement())}/> Weiteres Element hinzufügen</Button>
                    </div>
                </div>
                <div>
                    <div style={{
                        padding: '10px'
                    }}>
                    <Button primary fluid  onClick={(e) => devFunc()}>Änderungen speichern</Button>
                    </div>
                </div>
            </div>
            <div style={{
                flexGrow: 1
            }}>
                Configuration
            </div>
        </div>
    )
}